import { render } from "./LoginExtension.vue?vue&type=template&id=41e2332a"
import script from "./LoginExtension.vue?vue&type=script&lang=js"
export * from "./LoginExtension.vue?vue&type=script&lang=js"

import exportComponent from "/hpgdata/jenkins/workspace/kumc_hospital_front_prod/front-hospital/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__